// Configuración centralizada de la aplicación

// URL base de la API - se obtiene de las variables de entorno
// En desarrollo usa .env.development y en producción .env.production
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://devapi.agerespais.com'; // v2

// URL del WebSocket
export const WS_BASE_URL = `${API_BASE_URL}/ws`;

// Timeout para peticiones HTTP
export const API_TIMEOUT = 10000;

// Log de configuración en desarrollo
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Configuración de la aplicación:');
  console.log('📡 API Base URL:', API_BASE_URL);
  console.log('🔌 WebSocket URL:', WS_BASE_URL);
}
